<template lang="pug">
  div#custom-content(v-if="contentVisible")
    // Correct Answer, Score
    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap; align-items: baseline;") 
        div(style="flex-grow: 1;")
          el-row.margin-top-10(
              v-for="(option, index) in answerOptions"
              :gutter="30"
              :key="option"
            )
              el-col(
                :span="24"
                :style="index % 2 == 0 ? 'clear: left;' : ''"
              )
                el-checkbox(
                  v-model="answer"
                  :label="option"
                )
                  div(v-if="questionData.correct.includes(option)")
                    custom-point-badge
                      p.padding-right-20(v-html="option")
                  div(v-else)
                    custom-point-badge(value=0 type="danger")
                      p.padding-right-20(v-html="option")
                  
                  

</template>

<script>
  import shuffleArray from 'helpers/shuffleArray'
  import CustomPointBadge from '@/components/instructor/Question/Components/CustomPointBadge'

  export default {
    name: 'SelectPreview',

    components: {
      CustomPointBadge,
    },     

    props: {
      questionData: {
        type: Object,
        required: true,
      },

      contentVisible: {
        type: Boolean,
        required: true,
      },
    },

    computed: {
      answerOptions() {
        var options = this.questionData.correct.concat(this.questionData.others)
        return shuffleArray(options)
      },
    },
  }

</script>

